import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { HierarchicalTextBlock, ImageSkuBlock } from "@components"
import { CategoryText, SkuInfoBlockWrap } from "../@components"
import { useAdminNewListedList } from "../../../@hooks"


export default function associatedSkuColumn(isSkuMappingTable) {
	return [{
		name: "category", label: "Category",
		options: {
			display: 'excluded',
			customBodyRowRender: value => value || 'Not assigned'
		}
	}, {
		name: "skuBrand", label: "Brand",
		options: {
			display: 'excluded',
			customBodyRowRender: value => value || 'Not assigned'
		}
	}, {
		name: "qa", label: "Matched By",
		options: {
			display: 'excluded',
			customBodyRowRender: (value, row) => {
				if (!!value) return 'QA'
				if (!value && !!row.skuName) return 'Normalized'
				return '' 
			}
		}
	}, {
		name: "skuName", label: "Associated SKU",
		options: {
			filterType: 'textField',
			customBodyRowRenderLite: (value, rowData) => {
				return <RenderAssociatedSkuColumn value={value} row={rowData} isSkuMappingTable={isSkuMappingTable} />
			}
		}
	}, {
		name: 'IAIdSku', label: 'Only Mapped IA',
		options: {
			display: 'excluded', filterType: "checkbox",
			customBodyRowRender: value => value ? 'Yes' : 'No'
		}
	}, {
		name: 'IAIdSku', label: 'Info IA',
		options: {
			display: 'excluded', filterType: "textField",
			customBodyRowRender: (value, { IAIdSkuName, IAOptionsNameList }) => `${value || ''}${IAIdSkuName || ''}${IAOptionsNameList.join(', ')}`
		}
	}]
}


function RenderAssociatedSkuColumn({ row, value, isSkuMappingTable }) {
	const { handleClickSkuMapping } = useAdminNewListedList(row, row.date, row.siteID, row.productID, row.skuID)

	const isMapped = !!row.skuID

	const matchedByLabel = row.qa ? 'QA' : 'Normalized'
	const matchedByColor = row.qa ? 'info' : 'success'

	return <Box sx={{ display: 'flex', alignItems: 'center' }}>
		{!!isMapped && <ImageSkuBlock skuID={row?.skuID} skuName={value} hideName isClickable={isMapped} contentProps={{ sx: {margin: '', marginRight: 3} }} />}
		{!!isMapped && <Box sx={{ display: 'flex', flexDirection: 'column' }}>
			<SkuInfoBlockWrap sku={value} category={row.category} brand={row.skuBrand} />
			<HierarchicalTextBlock title="Matched by: " titleValue={<CategoryText label={matchedByLabel} color={matchedByColor} />} />
			{!!row.IAIdSku && <HierarchicalTextBlock
				supertitle="SKU ID assigned by AI: "
				supertitleValue={row.IAIdSku}
				title="SKU AI Name: "
				titleValue={row.IAIdSkuName}
				subtitle="IA options: "
				subtitleValue={(row.IAOptionsNameList || []).join(', ')}
			/>}
			{!!row.skuID && !isSkuMappingTable && <Box onClick={handleClickSkuMapping} sx={{ display: 'flex', alignItems: 'baseline', columnGap: '3px', cursor: "pointer"}}>
				<IconSeeker icon="circle-info" tooltip="View details" />
				<Typography variant="body2" sx={{ display: "inline", fontSize: "0.8rem" }}>
					Show Sku Mapping
				</Typography>
			</Box>}
		</Box>}
	</Box>
}